<template>
  <div :class="{navCollapsed:isSidebarNavCollapse}" style="height:100%;">
    <div v-if="!isPhone" style="height:100%;background:#f9faff;">
      <TopAside />
      <mainContent />
    </div>
    <div v-else style="height:100%;overflow-y:auto;" class="mobileMain">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

import mainContent from './component/mainContent';
import TopAside from './component/top-aside';
import MobileHome from './component/MobileHome';
import { mapState } from 'vuex';
export default {
  data () {
    return {
      isPhone: false,
      windowWidth: 0,
      height: 0
    };
  },
  computed: {
    ...mapState(['isSidebarNavCollapse'])
  },
  components: {
    mainContent,
    TopAside,
    MobileHome
  },
  watch: {
    '$store.state.screenWidth': function (newval, oldVal) { //监听屏幕宽度变化
      if (newval != oldVal) {
        this.windowWidth = newval;
        if (this.$store.state.screenWidth <= 768) {
          this.isPhone = true;
        } else {
          this.isPhone = false;
        }
      }
    }
  },
  created () {
    this.$store.state.screenWidth = document.documentElement.clientWidth; //窗口宽度
    if (this.$store.state.screenWidth <= 768) {
      this.isPhone = true;
    } else {
      this.isPhone = false;
    }
  },
  mounted () {
    let _that = this;
    window.onresize = function () {
      _that.$store.state.screenWidth = document.documentElement.clientWidth; //窗口宽度
    };
    let mainH = document.documentElement.clientHeight;
    this.height = mainH - 50;
  },
}
</script>

<style lang="scss" scoped>
.mobileMain {
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/page/layout/index.vue